import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardLayoutComponent } from '@core/layout/dashboard-layout/dashboard-layout.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  imports: [RouterModule, DashboardLayoutComponent]
})
export class MainComponent {}
